import React from 'react';
// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import { defineStyles, Classes } from 'styles/defineStyles';

interface Props {
  classes: any;
  children: any;
}

function TextBlock({ children, classes }: Props) {
  return <div className={classes.root}>{children}</div>;
}

const styles = defineStyles(theme => {
  return {
    root: {
      width: '100%',
      height: 300,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.grey[300],
      fontSize: 18,
      textAlign: 'center',
    },
  };
});

export default withStyles(styles)(TextBlock);
